<div class="container-full-width">
    <div class="page-container">
        <div class="product-list-container">
            <div fxLayout="row" fxLayoutAlign="space-between" class="top-container">
                <div class="breadcrumb-container">
                    <a href="/">Home /</a>
                    <a *ngFor="let category of breadcrumb; index as i" [href]="'/#/products/' + category.id">{{category.categoryEavs | getValueByAttribute:'displayName':'value'}} <span *ngIf="i < breadcrumb.length - 1">/</span></a>
                </div>
                <div class="sorting-container">
                    <app-sorting-select (onChange)="selectFilter($event)" [options]="sortBy" [selected]="selectedSort"></app-sorting-select>
                </div>
            </div>
            <h1>{{category.categoryEavs | getValueByAttribute:'displayName':'value'}}</h1>
            <div class="content" fxLayout="row" fxLayoutAlign="start">
                <div #filter class="filter-wrapper">
                    <app-product-filter 
                        [parentCategory]="parentCategory" 
                        [category]="category" 
                        (onChangeCategory)="onChangeCatgory($event)" 
                        (onChangeSize)="onChangeSize($event)" 
                        (onChangeColor)="onChangeColor($event)" 
                        (onClickClearFilter)="clearFilter()"
                        (onApplyMobileFilter)="mobileApplyFilter($event)">
                    </app-product-filter>
                </div>
                <div class="listing-wrapper">
                    <div fxLayout="row wrap">
                        <div *ngFor="let product of products" class="listing-item-wrapper">
                            <app-product-listing-item [product]="product"></app-product-listing-item>
                        </div>
                    </div>
                    <app-paginator [currentPage]="currentPage" [totalPage]="totalPageNum" (onPageChange)="onPageChange($event)"></app-paginator>
                </div>
            </div>
        </div>
    </div>
</div>
